import { memo } from 'react'
import {
  FieldPath,
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import {
  CheckboxProps,
  FormControl,
  FormControlLabel,
  FormControlLabelProps,
  FormHelperText,
  Checkbox as MuiCheckbox,
} from '@mui/material'

function Checkbox<
  T extends FieldValues = FieldValues,
  S extends FieldPath<T> = FieldPath<T>,
>({
  name,
  checkboxProps,
  className,
  ...props
}: Omit<FormControlLabelProps, 'control'> &
  UseControllerProps<T, S> & { checkboxProps?: CheckboxProps }) {
  const { t } = useTranslation()
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name })

  return (
    <FormControl error={!!error}>
      <FormControlLabel
        className={className}
        {...props}
        control={
          <MuiCheckbox
            checked={value}
            onChange={onChange}
            {...(checkboxProps || {})}
          />
        }
      />
      {error?.message && (
        <FormHelperText>
          {error?.type === 'custom'
            ? t(`error.${error.type}.${error.message}`)
            : error?.message}
        </FormHelperText>
      )}
    </FormControl>
  )
}

export default memo(Checkbox) as typeof Checkbox
